import { render, staticRenderFns } from "./TeamTimeline.vue?vue&type=template&id=494dbefc&scoped=true"
import script from "./TeamTimeline.vue?vue&type=script&lang=js"
export * from "./TeamTimeline.vue?vue&type=script&lang=js"
import style0 from "./TeamTimeline.vue?vue&type=style&index=0&id=494dbefc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494dbefc",
  null
  
)

export default component.exports